import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import * as moment from 'moment';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';

import { HttpStatusCodesEnum } from '@spa/api';

import { environment } from '../../../environments/environment';

import { CacheCollectionService } from '../services/cache-collection.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly protectedApiHeader: string;

  constructor(
    private router: Router,
    private cacheCollectionService: CacheCollectionService
  ) {
    this.protectedApiHeader = environment.customProtectedApiHeader;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(this.protectedApiHeader)) {
      const httpHeaders = request.headers.delete(this.protectedApiHeader).append('X-CSRF', '1');

      request = request.clone({ headers: httpHeaders, withCredentials: true });
    }

    return next.handle(request).pipe(
      tap(
        null,
        (error: HttpErrorResponse) => {
          if ([HttpStatusCodesEnum.Unauthorized, HttpStatusCodesEnum.Forbidden].indexOf(error.status) >= 0) {
            const timestamp = moment().unix();

            const collectionItemData = {
              statuses: [error.status],
              messages: ['Unauthorized']
            };

            if (this.cacheCollectionService) {
              this.cacheCollectionService.addItem(timestamp.toString(), collectionItemData);
            }

            this.router.navigate(['/en/error']).finally();
          }
        }
      )
    );
  }
}
